import moment from 'moment';

import j1939Dictionary from '../Static/j1939Dictionary.json';
import DM1FaultsConstants from './DM1FaultsConstants';

const STATUS_DISPLAY_MAP = new Map([
  ['positive', 'Active'],
  ['negative', 'Resolved'],
]);

export default class Dm1Utils {
  DM1FaultsConstants = new DM1FaultsConstants();

  formatDm1ForCsv(dm1, orgsMap) {
    const {
      Canbus: Can_Bus,
      FMI,
      GatewayName: Asset_Name,
      OC: Occurrence_Count,
      OrgId,
      SourceAddress,
      SPN,
      Transition,
      TriggeredAt,
    } = dm1;

    const Org_Name = orgsMap?.[OrgId]?.name ?? '',
      spnName = j1939Dictionary[SPN] ? j1939Dictionary[SPN].SPN_Name : SPN,
      Fault_Name = `${spnName} - ${this.DM1FaultsConstants.listFMIname[FMI]}`,
      Source = this.DM1FaultsConstants.listSourceAddress[SourceAddress],
      Status = STATUS_DISPLAY_MAP.get(Transition);

    return {
      Detected_At: moment(TriggeredAt).toISOString(),
      Asset_Name,
      Org_Name,
      Can_Bus,
      Fault_Name,
      Source,
      SPN,
      FMI,
      Occurrence_Count,
      Status,
    };
  }

  generateCsvFilename() {
    return `${new moment().format('YYYY-M-D_HH\u02f8mm\u02f8ss')}_Fault Record`;
  }
}
